import { push } from "connected-react-router";
import queryString from "query-string";

import * as types from "./actionTypes";
import { showModalSuccess, hideModalSuccess } from "./modalActions";
import { showAlertSuccess } from "./alertActions";
import customerService from "../services/customerService";
import { toggleLoader } from "./loaderActions";

export function loadInProgressCustomerProjectsSuccess(data) {
  return {
    type: types.LOAD_IN_PROGRESS_CUSTOMER_PROJECTS_SUCCESS,
    data
  };
}

export function loadCustomerSuccess(customers) {
  return {
    type: types.LOAD_CUSTOMER_SUCCESS,
    customers
  };
}

export function getCustomerSuccess(customer) {
  return { type: types.GET_CUSTOMER_SUCCESS, customer };
}

export function savingCustomer(status = true) {
  return { type: types.SAVING_CUSTOMER, savingCustomer: status };
}

export function createCustomerSuccess(customer) {
  return { type: types.CREATE_CUSTOMER_SUCCESS, customer };
}

export function updateCustomerSuccess(customer) {
  return { type: types.UPDATE_CUSTOMER_SUCCESS, customer };
}

export function deleteCustomerSuccess(customerId) {
  return { type: types.DELETE_CUSTOMER_SUCCESS, customerId };
}

export function requestCustomerId(customerId) {
  return (dispatch) => {
    dispatch({ type: types.REQUEST_CUSTOMER_ID, customerToDelete: customerId });
    dispatch(showModalSuccess("customerDeleteModal"));
  };
}

export function requestLocationId(locationId) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_LOCATION_ID,
      customerLocationToDelete: locationId
    });
    dispatch(showModalSuccess("locationDeleteModal"));
  };
}

export function requestContactId(contactID) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_CONTACT_ID,
      customerContactToDelete: contactID
    });
    dispatch(showModalSuccess("contactDeleteModal"));
  };
}
// if needed in future
// export function requestCollectionId(collectionId) {
//   return dispatch => {
//     dispatch({
//       type: types.REQUEST_COLLECTION_ID,
//       customerCollectionToDelete: collectionId
//     });
//     dispatch(showModalSuccess("collectionDeleteModal"));
//   };
// }

export function requestNoteId(noteId) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_NOTE_ID,
      customerNoteToDelete: noteId
    });
    dispatch(showModalSuccess("noteDeleteModal"));
  };
}

export function loadCustomers(query) {
  return async (dispatch) => {
    await dispatch(toggleLoader(true));
    return customerService
      .loadCustomers(query)
      .then(async (data) => {
        await dispatch(loadCustomerSuccess(data));
        await dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function getCustomer(id, showCUSTOMERDetails = false) {
  return (dispatch) =>
    customerService
      .getCustomer(id)
      .then((customer) => {
        dispatch(getCustomerSuccess(customer));
        if (showCUSTOMERDetails) {
          dispatch(showModalSuccess("customerDetailsModal"));
        }
      })
      .catch((error) => {
        dispatch(showAlertSuccess(error.description, "error"));
      });
}

export function createCustomer(customer) {
  return (dispatch) => {
    dispatch(savingCustomer());
    return customerService
      .createCustomer(customer)
      .then((createdCustomer) => {
        dispatch(createCustomerSuccess(createdCustomer));
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess("Customer created successfully", "success"));
        dispatch(push("/app/customers"));
      })
      .catch((error) => {
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess(error, "error"));
      });
  };
}

export function updateCustomer(customer) {
  return (dispatch) => {
    dispatch(savingCustomer());
    return customerService
      .updateCustomer(customer)
      .then((updatedCustomer) => {
        dispatch(updateCustomerSuccess(updatedCustomer));
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess("Customer updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteCustomer(id) {
  return (dispatch) =>
    customerService
      .deleteCustomer(id)
      .then(() => {
        dispatch(deleteCustomerSuccess(id));
        dispatch(showAlertSuccess("Customer deleted successfully", "success"));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function createLocation(customer, location) {
  return (dispatch) => {
    dispatch(savingCustomer());
    return customerService
      .createLocation(customer, location)
      .then((updatedCustomer) => {
        dispatch(updateCustomerSuccess(updatedCustomer));
        dispatch(savingCustomer(false));
        dispatch(hideModalSuccess("customerDetailsModal"));
        dispatch(showAlertSuccess("Location created successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateLocation(customer, location) {
  return (dispatch) => {
    dispatch(savingCustomer());
    return customerService
      .updateLocation(customer, location)
      .then((updatedCustomer) => {
        dispatch(updateCustomerSuccess(updatedCustomer));
        dispatch(savingCustomer(false));
        dispatch(hideModalSuccess("customerDetailsModal"));
        dispatch(showAlertSuccess("Location updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteLocation(customer, location) {
  return (dispatch) => {
    dispatch(savingCustomer());
    return customerService
      .deleteLocation(customer, location)
      .then((updatedCustomer) => {
        dispatch(updateCustomerSuccess(updatedCustomer));
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess("Location deleted successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function createContact(customer, contact) {
  return (dispatch) => {
    dispatch(savingCustomer());
    return customerService
      .createContact(customer, contact)
      .then((updatedCustomer) => {
        dispatch(updateCustomerSuccess(updatedCustomer));
        dispatch(savingCustomer(false));
        dispatch(hideModalSuccess("customerDetailsModal"));
        dispatch(showAlertSuccess("Contact created successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess(error, "error"));
      });
  };
}

export function updateContact(customer, contact) {
  return (dispatch) => {
    dispatch(savingCustomer());
    return customerService
      .updateContact(customer, contact)
      .then((updatedCustomer) => {
        dispatch(updateCustomerSuccess(updatedCustomer));
        dispatch(savingCustomer(false));
        dispatch(hideModalSuccess("customerDetailsModal"));
        dispatch(showAlertSuccess("Contact updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteContact(customer, contact) {
  return (dispatch) =>
    customerService
      .deleteContact(customer, contact)
      .then((updatedCustomer) => {
        dispatch(updateCustomerSuccess(updatedCustomer));
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess("Contact deleted successfully", "success"));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

// COLLECTIONS(// if needed in future)

// export function createCollection(customer, collection) {
//   return dispatch => {
//     dispatch(savingCustomer());
//     return customerService
//       .createCollection(customer, collection)
//       .then(updatedCustomer => {
//         dispatch(updateCustomerSuccess(updatedCustomer));
//         dispatch(savingCustomer(false));
//         dispatch(hideModalSuccess("customerDetailsModal"));
//         dispatch(showAlertSuccess("Collection created successfully", "success"));
//       })
//       .catch(error => {
//         dispatch(savingCustomer(false));
//         dispatch(showAlertSuccess(error, "error"));
//       });
//   };
// }

// export function updateCollection(customer, collection) {
//   return dispatch => {
//     dispatch(savingCustomer());
//     return customerService
//       .updateCollection(customer, collection)
//       .then(updatedCustomer => {
//         dispatch(updateCustomerSuccess(updatedCustomer));
//         dispatch(savingCustomer(false));
//         dispatch(hideModalSuccess("customerDetailsModal"));
//         dispatch(showAlertSuccess("Collection updated successfully", "success"));
//       })
//       .catch(error => {
//         dispatch(savingCustomer(false));
//         dispatch(showAlertSuccess(error.description, "error"));
//       });
//   };
// }

// export function deleteCollection(customer, collection) {
//   return dispatch =>
//     customerService
//       .deleteCollection(customer, collection)
//       .then(updatedCustomer => {
//         dispatch(updateCustomerSuccess(updatedCustomer));
//         dispatch(savingCustomer(false));
//         dispatch(showAlertSuccess("Collection deleted successfully", "success"));
//       })
//       .catch(error => dispatch(showAlertSuccess(error.description, "error")));
// }

// NOTES
export function createNote(customer, note) {
  return (dispatch) => {
    dispatch(savingCustomer());
    return customerService
      .createNote(customer, note)
      .then((updatedCustomer) => {
        dispatch(updateCustomerSuccess(updatedCustomer));
        dispatch(savingCustomer(false));
        dispatch(hideModalSuccess("customerDetailsModal"));
        dispatch(showAlertSuccess("Note created successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateNote(customer, note) {
  return (dispatch) => {
    dispatch(savingCustomer());
    return customerService
      .updateNote(customer, note)
      .then((updatedCustomer) => {
        dispatch(updateCustomerSuccess(updatedCustomer));
        dispatch(savingCustomer(false));
        dispatch(hideModalSuccess("customerDetailsModal"));
        dispatch(showAlertSuccess("Note updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteNote(customer, note) {
  return (dispatch) => {
    dispatch(savingCustomer());
    return customerService
      .deleteNote(customer, note)
      .then((updatedCustomer) => {
        dispatch(updateCustomerSuccess(updatedCustomer));
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess("Note deleted successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCustomer(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function loadInProgressCustomerProjects(query) {
  return async (dispatch) => {
    await dispatch(toggleLoader(true));
    return customerService
      .loadInProgressCustomerProjects(
        queryString.stringify(query, {
          arrayFormat: "bracket"
        })
      )
      .then(async (data) => {
        await dispatch(loadInProgressCustomerProjectsSuccess(data));
        await dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function clearInProgressCustomerProjects() {
  return {
    type: types.CLEAR_IN_PROGRESS_CUSTOMER_PROJECTS_SUCCESS
  };
}
